import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerAccount } from '@proximus/common-business-logic';
import { CustomerService, TranslationService } from '@proximus/ng-common';
import {
  getFirstJointOffer,
  MobileProduct,
  Option,
} from '@dch/products-business-logic';
import { Product } from '@proximus/usage-business-logic';
import { combineLatest } from 'rxjs';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { getPiiServiceId } from 'src/app/shared/pii/pii.utils';
import { getUsageProductFrom } from 'src/app/shared/usage/util';
import {
  GetEBUProductDetails,
  GetProductDetails,
} from 'src/app/store/actions/product-details.actions';
import {
  ApplicationState,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from 'src/app/store/reducers';

@Component({
  selector: 'mprd-mobile-usage-pxsplus',
  templateUrl: './mobile-usage-pxsplus.component.html',
})
export class MobileUsagePxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: MobileProduct;
  usageProduct: Product;
  customerAccount: CustomerAccount;
  isEBU: boolean;
  jointOffer: Option;
  hasError: boolean;
  isPending: boolean;

  remainingDaysLabel: string;

  isProductOfferEligibleForPenalty = false;

  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private customerService: CustomerService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        combineLatest([
          this.route.params,
          this.customerService.getCustomerAccount(),
        ]).subscribe((res) => {
          const customerAccount = res[1];
          if (customerAccount) {
            this.customerAccount = customerAccount;
            this.isEBU = this.customerAccount.isEBU();
            if (this.isEBU) {
              this.store.dispatch(
                new GetEBUProductDetails({
                  productType: 'mobile',
                  serviceId,
                }),
              );
            } else {
              this.store.dispatch(
                new GetProductDetails({
                  productType: 'mobile',
                  serviceId,
                }),
              );
            }
          }
        }),
      );

      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.mobileProductDetails) {
            this.selectedProduct = value.mobileProductDetails;
            if (this.selectedProduct) {
              this.usageProduct = getUsageProductFrom(this.selectedProduct);
              this.jointOffer = getFirstJointOffer(this.selectedProduct);
              this.isProductOfferEligibleForPenalty =
                !!this.jointOffer?.isProductOfferEligibleForPenalty;
            }
          }
        }),
      );
      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );
      this.addSubscription(
        this.store.select(getProductDetailsPending).subscribe((pending) => {
          this.isPending = pending;
        }),
      );
      this.translationService.parse(this.elementRef.nativeElement);
    } else {
      this.router.navigate(['/overview']);
    }
  }

  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
    }
  }
}
